import { useNavigate } from 'react-router-dom'
import videoSrc from '../../assets/images/video.mp4'
import cardBg from '../../assets/images/card_bg.svg'
import arrowRight from '../../assets/images/arrow-right.svg'
import Button from '../ui/Button'

function Hero() {
  const navigate = useNavigate()

  // Handler to open the custom quote request page
  const handleRequestQuoteClick = () => {
    navigate('/request-quote')
  }

  const stats = [
    { val: "99%", label: "Uptime - Platform Stability" },
    { val: "1,200+", label: "Orders Delivered" },
    { val: "100%", label: "Positive Feedback" },
    { val: "50+", label: "Active Partners" },
  ];
  return (
    <section className="relative w-full  overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover z-0"
        style={{ filter: "brightness(0.4)" }}
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Content */}
      <div className="relative z-10 w-full min-h-[120dvh] flex flex-col justify-center items-start px-6 container mx-auto">
        <div className="max-w-4xl">
          {/* CTA Card */}
          <div
            className=" p-12 max-w-7xl py-12 backdrop-blur-sm"
            style={{
              backgroundImage: `url(${cardBg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundColor: "rgba(31, 41, 55, 0.7)",
            }}
          >
            {/* Main Heading */}
            <h1 className="special-header text-4xl sm:text-6xl font-bold text-white mb-8 leading-tight">
              SMART LOGISTICS THAT MOVE AT
              <br />
              THE <span className="text-[#F55109]">SPEED</span> OF YOUR BUSINESS
            </h1>

            {/* Subtitle */}
            <p className="text-lg text-gray-200 mb-6">
              Efficient logistic solution for your businesses
            </p>

            {/* CTA Button */}
            <Button
              title="Request a Custom Quote"
              onClick={handleRequestQuoteClick}
              variant="primary"
              size="md"
              icon={arrowRight}
              iconAlt="Arrow Right"
              className="group"
            />
          </div>
        </div>
      </div>

      {/* Statistics Section - Footer */}
      <div className="absolute inset-x-0 bottom-0 z-10 bg-black/30 backdrop-blur-md py-5 sm:py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-8">
          {stats.map((s, i) => (
            <div key={i} className="text-center">
              <div className="text-xl sm:text-2xl md:text-4xl lg:text-5xl font-thin text-white mb-1">
                {s.val}
              </div>
              <div className="text-xs sm:text-sm md:text-base text-gray-400">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Hero
